import ModelFactoryChoice, {IModelFactoryChoices} from "../ModelFactoryChoice";
import {RouteKey, FactoryID} from "../../type-interface/ModelFactoryType";
import {IRouteIDs} from "../../type-interface/ModelFactoryInterface";
import {getManager} from "../../../manager/Manager";
import {ISideMenuIcons} from "../../../../tsx/element/button/IButton";
import {PostDataChoice} from "../../../data/subject/PostDataFactory";



interface IProps
{
    id?: string;
    name?: string;
    publicID?: string;
    nextFactoryID?:FactoryID;
    derivedRouteIDs?:IRouteIDs
    calculateRouteIDs?:() => IRouteIDs
    hiddenRoute?:boolean;
    requiresOrganisationPayment?:boolean;

    appearSelectedFor?:IRouteIDs[],
    requiresLogin?: boolean,
    isSecondaryRoute?: boolean,
    tabIcon?: string,
    sideMenuIcons?:ISideMenuIcons;
    pageID?:string;
    className?:string
    conditionalClassName?:() => string
}

export default class RouteChoice extends ModelFactoryChoice
{
    navigationRouteKey: RouteKey | null = null;
    nextFactoryID:FactoryID | null = null;
    routeIDs:IRouteIDs = {};
    derivedRouteIDs:IRouteIDs = {};
    calculateRouteIDs:(() => IRouteIDs)|null = null;

    publicID:string = "";
    baseURL:string = "";
    href:string = "";
    realPath:string = "";
    determinedHref:string|null = null;
    selectedForHrefs:string[] = [];
    isUnknown:boolean = false;
    hiddenRoute:boolean = false;
    requiresLogin:boolean = false;
    requiresOrganisationPayment:boolean = false;
    isFromFirstChildModel:boolean = false;
    isSecondaryRoute:boolean = false;


    appearSelectedFor:IRouteIDs[] = [];
    tabIcon:string|null = null;
    sideMenuIcons:ISideMenuIcons|null = null;
    pageID:string|null = null;
    postDataChoice:PostDataChoice|null = null;
    className?:string
    conditionalClassName?:() => string


    constructor(props?:IProps|null, id?:string)
    {
        super(id ?? props?.id)

        if(props){
            this.name = props.name ?? this.name;
            this.publicID = props.publicID ?? this.publicID;
            this.nextFactoryID = props.nextFactoryID ?? this.nextFactoryID;
            this.derivedRouteIDs = props.derivedRouteIDs ?? this.derivedRouteIDs;
            this.calculateRouteIDs = props.calculateRouteIDs ?? this.calculateRouteIDs;
            this.hiddenRoute = props.hiddenRoute ?? this.hiddenRoute;
            this.requiresOrganisationPayment = props.requiresOrganisationPayment ?? this.requiresOrganisationPayment;

            this.appearSelectedFor = props.appearSelectedFor ?? this.appearSelectedFor;
            this.requiresLogin = props.requiresLogin ?? this.requiresLogin;
            this.tabIcon = props.tabIcon ?? this.tabIcon;
            this.sideMenuIcons = props.sideMenuIcons ?? this.sideMenuIcons;
            this.pageID = props.pageID ?? null;
            this.isSecondaryRoute = props.isSecondaryRoute ?? false;
            this.className = props.className ?? this.className;
            this.conditionalClassName = props.conditionalClassName ?? this.conditionalClassName;
        }
    }

    getHref(): string
    {
        if(this.determinedHref !== null){
            return this.determinedHref;
        }
        this.determinedHref = getManager().navigation.getChoiceUiHref(this);
        return this.determinedHref;
    }

    isSelected()
    {
        const activeHref = getManager().navigation.model.href;
        return this.getHref() === activeHref || this.selectedForHrefs.includes(activeHref);
    }

    isPathSelected()
    {
        const realPath = getManager().navigation.model.realPath;
        return realPath.includes(this.realPath);
    }

    isAppearSelected()
    {
        if(this.isSelected()){
            return true;
        }
        const routeIDs = getManager().navigation.model.routeIDs;
        for(let inSelectedFor of this.appearSelectedFor){
            let valid = true;
            for(let routeKey in inSelectedFor){
                const routeID = inSelectedFor[routeKey];
                if(!routeID){
                    if(routeIDs[routeKey]){
                        valid = false;
                        break;
                    }
                } else if(routeIDs[routeKey] !== routeID){
                    valid = false;
                    break;
                }
            }
            if(valid){
                return true;
            }
        }
        return false;
    }


    clone(cloneTo?: RouteChoice): RouteChoice
    {
        return super.clone(cloneTo ? cloneTo : new RouteChoice(null, this.id)) as RouteChoice;
    }
}

export interface IRouteChoices extends IModelFactoryChoices
{
    [key: string]: RouteChoice;
}